export const PACKAGE_VERSION = '1.2.0';
//# sourceMappingURL=constants.js.map